<div class="d-flex">
  <a class="navbar-brand me-1 me-sm-3" href="#">
    <div class="d-flex align-items-center">
      <img
        class="me-2"
        src="../assets/img/icon/icon.svg"
        alt=""
        width="109"
        height="40"
      />
    </div>
  </a>
</div>
<div class="navbar ms-auto" id="navbarStandard">
  <ul class="navbar-nav" data-top-nav-items="data-top-nav-items">
    <li class="nav-item">
      <a
        class="nav-link"
        href="#"
        role="button"
        aria-haspopup="true"
        id="about-us"
        >{{ "topNav.news" | translate }}</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        href="#"
        role="button"
        aria-haspopup="true"
        id="faqs"
        >{{ "topNav.mission" | translate }}</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/projects"
        role="button"
        aria-haspopup="true"
        id="projects"
        >{{ "topNav.projects" | translate }}</a
      >
    </li>
  </ul>
</div>
<ul class="navbar-nav navbar-nav-icons flex-row align-items-center">
  <!--li class="nav-item d-none d-sm-block">
    <a class="nav-link px-0">
      <span class="far fa-comment-alt"></span>
    </a>
  </li-->
  @if (authStore.isLoggedIn()) {
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        href="#"
        id="profileDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="fas fa-user"></span
      ></a>
      <div class="dropdown-menu py-0" aria-labelledby="profileDropdown">
        <div class="py-2 rounded-3">
          <a class="dropdown-item" routerLink="/profile">{{
            "topNav.profile" | translate
          }}</a
          ><a class="dropdown-item" routerLink="/auth/logout">{{
            "topNav.logout" | translate
          }}</a>
        </div>
      </div>
    </li>
  } @else {
    <li class="nav-item">
      <a class="nav-link px-0" routerLink="/auth/login">
        <span class="fas fa-user"></span>
      </a>
    </li>
  }
</ul>
@if (authStore.isAdmin()) {
  <button class="btn btn-primary ms-3" (click)="goToAdmin()">
    {{ "general.admin" | translate }}
  </button>
}
